import { render, staticRenderFns } from "./UISelectBox.vue?vue&type=template&id=506c0fd7&scoped=true"
import script from "./UISelectBox.vue?vue&type=script&lang=js"
export * from "./UISelectBox.vue?vue&type=script&lang=js"
import style0 from "./UISelectBox.vue?vue&type=style&index=0&id=506c0fd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c0fd7",
  null
  
)

export default component.exports